import { render, staticRenderFns } from "./AppSwitcher.vue?vue&type=template&id=948617b4&scoped=true&"
import script from "./AppSwitcher.vue?vue&type=script&lang=ts&"
export * from "./AppSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./AppSwitcher.vue?vue&type=style&index=0&id=948617b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948617b4",
  null
  
)

export default component.exports